import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  isTimeZone,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface Suite8Service {
  endpoint: string;
  timezone: string;
  username: string;
  password: string;
  roomBillFolioWindows: string;
}

const FOLIO_WINDOWS = /^\d+(,\d+)*$/;

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    endpoint: '',
    timezone: '',
    username: '',
    password: '',
    roomBillFolioWindows: '1',
  },
  features: {},
  cron: [{ name: 'full', task: 'full_reservation_sync' }],
  webhooks: [],
});

export const suite8: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as Suite8Service;

    test(`${SERVICE}.endpoint`, t('validations.required'), () => {
      enforce(service.endpoint).isNotBlank();
    });

    omitWhen(!service.endpoint, () => {
      test(`${SERVICE}.endpoint`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.endpoint)).isTruthy();
      });
    });

    test(`${SERVICE}.timezone`, t('validations.required'), () => {
      enforce(service.timezone).isNotBlank();
    });

    omitWhen(!service.timezone, () => {
      test(`${SERVICE}.timezone`, t('validations.invalid'), () => {
        enforce(isTimeZone(service.timezone)).isTruthy();
      });
    });

    test(`${SERVICE}.username`, t('validations.required'), () => {
      enforce(service.username).isNotBlank();
    });

    test(`${SERVICE}.password`, t('validations.required'), () => {
      enforce(service.password).isNotBlank();
    });

    omitWhen(!service.roomBillFolioWindows, () => {
      test(`${SERVICE}.roomBillFolioWindows`, t('validations.invalid'), () => {
        enforce(service.roomBillFolioWindows).matches(FOLIO_WINDOWS);
      });
    });
  },
};
